import { makeStyles } from '@material-ui/core/styles';
import { modalPaperStyle } from '../../../../shared/components/RedesignModal/RedesignModal.styles';
import { redesignTheme } from '../../../../theme';

const { colors, fonts, fontSize, spacing, radius, sizes, breakpoints } = redesignTheme;

export const usePendingTestsModalStyles = makeStyles(() => ({
  // Additive overlay overrides: scrollable, kept inside the iOS visible viewport
  overlayScroll: {
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    height: '100%',
    maxHeight: '100vh',
    '@supports (height: 100dvh)': {
      maxHeight: '100dvh',
    },
  },
  modal: {
    ...modalPaperStyle,
    maxWidth: sizes.modalMaxWidth,
    maxHeight: '90vh',
    margin: 'auto',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '@supports (height: 100dvh)': {
      maxHeight: '90dvh',
    },
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      maxHeight: '80vh',
      padding: spacing.sm,
      '@supports (height: 100dvh)': {
        maxHeight: '80dvh',
      },
    },
  },
  headerBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    width: '100%',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.md,
    width: '100%',
  },
  title: {
    margin: 0,
    flex: 1,
    minWidth: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.lg,
    color: colors.primaryDark,
    letterSpacing: 0.4,
    lineHeight: 1.4,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.base,
    },
  },
  closeButton: {
    flexShrink: 0,
    margin: -4,
    padding: 4,
    color: colors.primaryDark,
    '&:hover': {
      backgroundColor: colors.progressTrack,
    },
  },
  closeIcon: {
    width: 24,
    height: 24,
  },
  subtitle: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.primaryDark,
    letterSpacing: 0.32,
    lineHeight: 'normal',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    width: '100%',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.md,
    width: '100%',
    padding: spacing.sm,
    border: `1px solid ${colors.border}`,
    borderRadius: radius.sm,
    backgroundColor: colors.white,
    cursor: 'pointer',
    textAlign: 'left',
    boxSizing: 'border-box',
    '&:hover': {
      backgroundColor: colors.hoverSurface,
    },
  },
  itemTitle: {
    flex: 1,
    minWidth: 0,
    margin: 0,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.base,
    color: colors.primary,
    letterSpacing: 0.32,
    lineHeight: 'normal',
  },
  timeRow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: spacing.xs,
    flexShrink: 0,
    color: colors.primaryDark,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    letterSpacing: 0.32,
    whiteSpace: 'nowrap',
  },
  timeIcon: {
    width: 20,
    height: 20,
    color: colors.primaryDark,
  },
}));
